import _get from 'lodash/get';
import { connect } from 'react-redux';
import { hide } from 'js/store/actions/modal';
import { postFeedback } from 'js/store/actions/feedbackMenu';
import { mapTextVariableNameToStaticLocalizedText } from 'js/helpers/localization';
import FeedbackOrDownloadMenuBody from 'js/components/legacy/FeedbackOrDownloadMenuBody';
export default connect(function (state) {
  return {
    menuLoading: state.feedbackMenu.loading,
    menuSubmitting: state.feedbackMenu.submitting,
    menuLoadError: !state.feedbackMenu.loading && !state.feedbackMenu.metadata,
    menuLoadErrorMessage: mapTextVariableNameToStaticLocalizedText('FEEDBACK_MENU_ERROR_MESSAGE'),
    features: _get(state.feedbackMenu, 'metadata.features'),
    featuresTitle: _get(state.feedbackMenu, 'metadata.feedback_title'),
    contactCheckboxText: _get(state.feedbackMenu, 'metadata.contact_checkbox'),
    submitButtonText: _get(state.feedbackMenu, 'metadata.button_feedback'),
    provideFeedbackTitle: _get(state.feedbackMenu, 'metadata.general_feedback_title'),
    provideFeedbackSubtitle: _get(state.feedbackMenu, 'metadata.general_feedback_subtitle'),
    feedbackSubmitFailureMessage: mapTextVariableNameToStaticLocalizedText('FEEDBACK_MENU_SUBMIT_ERROR_MESSAGE'),
    isMobileWidth: state.device.isMobileWidth
  };
}, function (dispatch) {
  return {
    submitFeedback: function submitFeedback(postFormData) {
      return dispatch(postFeedback(postFormData));
    },
    modalClose: function modalClose() {
      return dispatch(hide());
    }
  };
})(FeedbackOrDownloadMenuBody);